<template>
<div>
  <Header></Header>
  <form 
    @submit.prevent="submitNewAddress" 
    novalidate
  >
    <b-container class="add-new-address-container">
      <b-row no-gutters>
        <b-col>
          <h2 class="new-address-header">{{'newAddressAddAddress' | localize}}</h2>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12" md="7">
          <b-row 
            no-gutters 
            class="new-address-entry-field"
          >
            <b-col 
              class="new-address-entry-field"  
              cols="11" sm="8" md="8" xl="7"
            >          
              <div class="new-address-description">{{'newAddressBillNumber' | localize}}:</div>
              <input 
                v-model="bill_number"
                type="text"
                class="form-control"
              >  
              <div 
                  class="form-description"
                  v-if="!$v.bill_number.$dirty && !$v.bill_number.required"
              >
              </div>
              <div 
                  class="form-description-error"
                  v-if="$v.bill_number.$dirty && !$v.bill_number.required"
              >
                  {{'newAddressRequiredInput' | localize}}
              </div>
              <div 
                  class="form-description-error"
                  v-if="$v.bill_number.$dirty && !$v.bill_number.minLength"
              >
                  {{'newAddressMinLength' | localize}}
              </div>     
              <div 
                  class="form-description-error"
                  v-if="$v.bill_number.$dirty && !$v.bill_number.numeric"
              >
                  {{'newAddressNumbersOnly' | localize}}
              </div>   
            </b-col>
          </b-row>
          <b-row 
            no-gutters 
            class="new-address-entry-field"
          >
            <b-col 
              class="new-address-entry-field"  
              cols="11" sm="8" md="8" xl="7"
            >
              <div class="new-address-description">{{'newAddressLatPaySumm' | localize}}:</div>
              <input 
                v-model="payment_amount"
                type="text"
                class="form-control"
                @keyup="fixComa()"
                @blur="fixComa()"
                @change="fixComa()"
              >
              <div 
                  class="form-description"
                  v-if="!$v.payment_amount.$dirty && !$v.payment_amount.required"
              >
                 <span class="mx-4">{{'newAddressLastPaySumm' | localize}}</span>  
                 <br>
                <span class="">{{'newAddressLastPaySumm2' | localize}}</span>
                  
              </div> 
              <div 
                  class="form-description-error"
                  v-if="$v.payment_amount.$dirty && !$v.payment_amount.required"
              >
                  {{'newAddressRequiredInput' | localize}}
              </div> 
              <div 
                  class="form-description-error"
                  v-if="$v.payment_amount.$dirty && !$v.payment_amount.numeric"
              >
                 {{'newAddressNumbersOnly2' | localize}}
              </div>     
            </b-col>
          </b-row>
        </b-col>
        <b-col 
          cols="12" md="5" 
          class="d-flex  mt-sm-0 flex-column justify-content-center "
        >
          <b-row no-gutters>
            <b-col class="new-address-entry-field" >
              <vue-recaptcha 
                  class="captcha mt-5"
                  :sitekey="captcha_key" 
                  size="compact"  
                  @verify="onVerify"
                  @expired="onExpired"
                  :loadRecaptchaScript="true"
              ></vue-recaptcha>
            </b-col>
          </b-row>
          <b-row no-gutters> 
            <b-col class="new-address-entry-field">
            <b-button 
              type="submit"
              class="px-4 mt-3 style-button button-pay-all"
              size="lg" 
              variant="outline-danger"
            >
                {{'newAdressSave' | localize}} 
                <div class="style-button-icon"> 
                  <b-icon icon="journal-check" ></b-icon> 
                </div> 
            </b-button>       
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </form>
</div>
  

</template>
<script>
import Header from '../components/Header'
import config from '@/config'
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha';
import { validationMixin } from 'vuelidate'
import { required, minLength, numeric, decimal } from 'vuelidate/lib/validators'
const ROUTE_PREFIX = config.ROUTE_PREFIX
export default {
  name: 'NewAddress',
  mixins: [validationMixin],
  data: ()=> ({
    captcha_key: config.CAPTCHA_KEY,
    captcha_verify: null,
    bill_number: '',
    payment_amount:'',
    message: ''
  }),
  validations: {
      bill_number: {required, minLength: minLength(8), numeric},
      payment_amount: { required, decimal},
  },
  computed: mapGetters(['responseMessage', 'locale']),
  mounted(){
    localStorage.setItem('weltumLastUrl', window.location.pathname)
  },
  methods: {
    fixComa(){
      const regexp1 = /[^\d-.]/ig;
      const regexp2 = /-/ig;
      this.payment_amount = this.payment_amount.replaceAll(',', '.');
      let tmp_arr = this.payment_amount.split('.')
      if(tmp_arr.length > 1){
        this.payment_amount = tmp_arr.shift()
        this.payment_amount = this.payment_amount + '.' + tmp_arr.join('');
      }
      this.payment_amount = this.payment_amount.replaceAll(regexp1, '')
      if(this.payment_amount.indexOf('-') == 0){
        this.payment_amount = '-' + this.payment_amount
            .replaceAll(regexp2, '')
      }else{
        this.payment_amount = this.payment_amount
            .replaceAll(regexp2, '')
      }
      if( this.payment_amount.indexOf('.') > 0 && this.payment_amount.length > this.payment_amount.indexOf('.') + 2) {
        this.payment_amount = parseFloat(this.payment_amount).toFixed(2).toString()
      }
    },
    onVerify(response) {
        this.captcha_verify = response
    },
    onExpired() {
    },
    resetRecaptcha () {
        this.$refs.recaptcha.reset()
    },
    submitNewAddress(){!this.captcha_verify ? console.log('captcha error') : this.sendForm()},
    async sendForm(){
      if(this.$v.$invalid){
        this.$v.$touch()
      } else {
        const user = {
            login: localStorage.weltumAuth,
            kod_lica: this.bill_number,
            last_opl: this.payment_amount,
            secret_key: localStorage.weltumKey
        }
        await this.$store.dispatch('addNewAddress', user)
        this.message = this.responseMessage
        if(this.message === 'Сумма не равна контрольной !'){
          this.$messageLocalized("wrongSum")
                    
        } else if( this.message === 'Нет такого счета   !' ){
          this.$messageLocalized('wrongAccountNumber')
                  
        } else if( this.message === 'Пользователь не зарегистрирован  !' ){
          this.$messageLocalized('wrongLogin')
          
        } else if( this.message === 'OK' ){
          this.$messageLocalized('accountCreated')
          
          this.$router.push({ path: `${ROUTE_PREFIX}/` })
        }
      } 
    }
  },
  components: { VueRecaptcha, Header }
}
</script>